export const getNCFileFromVersions = (versions: Array<{ isFavorite?: boolean; sequenceNumber: number }> | undefined) => {
  let ncFile = null;
  if (versions?.length) {
    ncFile = versions.find((v) => v.isFavorite);
    if (!ncFile) {
      ncFile = versions[0];
      versions.forEach((v) => {
        if (v.sequenceNumber > ncFile.sequenceNumber) {
          ncFile = v;
        }
      });
    }
  }
  return ncFile;
};

export const getDocumentTypeName = ({
  documentType,
  documentCategories,
}: {
  documentType: string | null;
  documentCategories: { items?: Array<{ value: string; name: string }> } | null;
}) => {
  if (!documentType || !documentCategories?.items) return null;
  const category = documentCategories.items.find((item) => item.value === documentType);
  return category ? category.name : documentType;
};

export const getNcFileTimesConfig = ({
  data,
  secondsToInputDisplay,
  shouldConvertSecToDisplay = true,
}: {
  data: Record<string, unknown>;
  secondsToInputDisplay: (value: unknown) => unknown;
  shouldConvertSecToDisplay?: boolean;
}) => ({
  setup: {
    ideal: data?.clampingDetails?.setupTimeSecond,
    scheduled: data?.clampingDetails?.scheduledSetupTimeInSeconds,
    paid: data?.clampingDetails?.paidSetupTimeSecond,
    manualIdeal: data?.clampingDetails?.useManualIdealSetupTime,
    manualScheduled: data?.clampingDetails?.useManualScheduledSetupTime,
    manualPaid: data?.clampingDetails?.useManualPaidTimes,
    idealAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageIdealSetupSecs)
      : data?.statisticsOverall?.averageIdealSetupSecs,
    scheduledAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageSetupSecs)
      : data?.statisticsOverall?.averageSetupSecs,
    paidAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averagePaidSetupSecs)
      : data?.statisticsOverall?.averagePaidSetupSecs,
    fastest: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageIdealSetupSecs)
      : data?.statisticsOverall?.averageIdealSetupSecs,
    average: shouldConvertSecToDisplay ? secondsToInputDisplay(data?.statisticsOverall?.averageSetupSecs) : data?.statisticsOverall?.averageSetupSecs,
    amount: data?.statisticsOverall?.productionBatchCount,
  },
  active: {
    ideal: data?.clampingDetails?.runTimePerPcsSecond,
    scheduled: data?.clampingDetails?.scheduledRunTimeInSeconds,
    paid: data?.clampingDetails?.paidRunTimePerPcsSecond,
    manualIdeal: data?.clampingDetails?.useManualIdealRunTime,
    manualScheduled: data?.clampingDetails?.useManualScheduledRunTime,
    manualPaid: data?.clampingDetails?.useManualPaidTimes,
    idealAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageIdealActiveSecs)
      : data?.statisticsOverall?.averageIdealActiveSecs,
    scheduledAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageActiveSecs)
      : data?.statisticsOverall?.averageActiveSecs,
    paidAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averagePaidActiveSecs)
      : data?.statisticsOverall?.averagePaidActiveSecs,
    fastest: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageIdealActiveSecs)
      : data?.statisticsOverall?.averageIdealActiveSecs,
    average: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageActiveSecs)
      : data?.statisticsOverall?.averageActiveSecs,
    amount: data?.statisticsOverall?.quantity,
  },
  change: {
    ideal: data?.clampingDetails?.changeTimePerPcsSecond,
    scheduled: data?.clampingDetails?.scheduledChangeTimeInSeconds,
    paid: data?.clampingDetails?.paidChangeTimePerPcsSecond,
    manualIdeal: data?.clampingDetails?.useManualIdealChangeTime,
    manualScheduled: data?.clampingDetails?.useManualScheduledChangeTime,
    manualPaid: data?.clampingDetails?.useManualPaidTimes,
    idealAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageIdealChangeSecs)
      : data?.statisticsOverall?.averageIdealChangeSecs,
    scheduledAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageChangeSecs)
      : data?.statisticsOverall?.averageChangeSecs,
    paidAutomatic: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averagePaidChangeSecs)
      : data?.statisticsOverall?.averagePaidChangeSecs,
    fastest: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageIdealChangeSecs)
      : data?.statisticsOverall?.averageIdealChangeSecs,
    average: shouldConvertSecToDisplay
      ? secondsToInputDisplay(data?.statisticsOverall?.averageChangeSecs)
      : data?.statisticsOverall?.averageChangeSecs,
    amount: data?.statisticsOverall?.quantity,
  },
});
